<template>
  <ul :class="nextLevel">
    <li
      v-for="(element, slug) in content[nextLevel]"
      :key="slug"
      :class="{ active: isDropdownMenuVisible == slug }"
    >
      <router-link
        :to="{ query: { ...prevQuery, [nextLevel]: slug } }"
        @click.native="$emit('closeModal')"
      >
        {{ element.label }}
      </router-link>

      <button
        v-if="element[nextNextLevel] != undefined"
        type="button"
        class="toggle-dropdown-button"
        :aria-label="
          (isDropdownMenuVisible == slug
            ? labels.SEN_GUIDA_MOBILEMENU_COLLAPSE_LABEL
            : labels.SEN_GUIDA_MOBILEMENU_EXPAND_LABEL) + element.label
        "
        @click="
          isDropdownMenuVisible === slug
            ? (isDropdownMenuVisible = '')
            : (isDropdownMenuVisible = slug)
        "
      ></button>

      <MobileList
        @closeModal="$emit('closeModal')"
        :level="level + 1"
        :content="element"
        v-if="element[nextNextLevel] != undefined"
        :prevQuery="{ ...prevQuery, [nextLevel]: slug }"
      />
    </li>
  </ul>
</template>

<script>
import content from "@/data/content";
import labels from "@/data/labels.json";

export default {
  name: "MobileList",
  props: {
    level: {
      type: Number,
      default: 0,
    },

    content: {
      type: Object,
      default: function () {
        return content;
      },
    },

    prevQuery: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      labels,
      isDropdownMenuVisible: "",
    };
  },
  computed: {
    nextLevel() {
      return `level${this.level + 1}`;
    },
    nextNextLevel() {
      return `level${this.level + 2}`;
    },
  },
};
</script>
